export const pagesTexts = {
  inscritos: {
    pageTitle: 'Inscritos',
    pageSubtitle: 'Lista de inscritos',
    newItemBtn: 'Adicionar cadastro',
    newModalTitle: 'Adicionar cadastro',
    newModalSubtitle: null,
    detailsModalTitle: 'Detalhes do cadastro',
    detailsModalSubtitle: null
  },
  'lista-de-espera': {
    pageTitle: 'Lista de Espera',
    pageSubtitle: 'Lista de espera do evento',
    newItemBtn: 'Adicionar cadastro',
    newModalTitle: 'Adicionar cadastro',
    newModalSubtitle: null,
    detailsModalTitle: 'Detalhes do cadastro',
    detailsModalSubtitle: null
  },
  'lista-de-desistencia': {
    pageTitle: 'Desistência',
    pageSubtitle: 'Lista de desistência do evento',
    newItemBtn: 'Adicionar cadastro',
    newModalTitle: 'Adicionar cadastro',
    newModalSubtitle: null,
    detailsModalTitle: 'Detalhes do cadastro',
    detailsModalSubtitle: null
  }
}